// Vendor imports
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { CapsuleButton } = require('client-v2/common/components/buttons')
const socialProviders = require('./providers')

const bem = BemEntity('AuthSection')

class AuthSection extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    this.onAppDownloadClick = this.onAppDownloadClick.bind(this)
    this.onSocialProviderClick = this.onSocialProviderClick.bind(this)
  }

  // Event handler methods

  onAppDownloadClick() {
    const { isIos } = this.props
    const platform = isIos ? 'ios' : 'android'
    this.props.onAppDownload(platform)
  }

  onSocialProviderClick(event) {
    const { provider } = event.currentTarget.dataset
    this.props.onSocialProviderAuth(provider)
  }

  renderDesktopAuthIcon(){
    return (
        tag(CapsuleButton, {
          className: bem.element('auth-button-primary', 'desktop'),
          'data-provider': 'google',
          onClick: this.onSocialProviderClick
        },
          tag('div', {
            className: bem.element('auth-icon')
          }),
          'Sign in with Google'
        )
    )
  }

  renderMobileAuthIcon(){
    const { isIos, isAndroid, downloadHref  } = this.props
    return (
        tag(CapsuleButton, {
          className: bem.element('auth-button-primary', 'mobile'),
          href: downloadHref,
          onClick: this.onAppDownloadClick
        },
          tag('div', {
            className: bem.element('auth-icon', {
              ios: isIos,
              android: isAndroid
            })
          }),
          'Download the app'
        )
    )
  }

  render() {
    const { isMobile } = this.props
    return (
      tag('div', {
        className: bem.element('auth-section-wrapper')
      },
        this.props.isMobile ?
          this.renderMobileAuthIcon() :
          this.renderDesktopAuthIcon(),
          tag('div', {
            className: bem.element('auth-buttons-secondary')
          },
            isMobile ?
              'Or sign in with:' :
              'Or use:',
            tag('div', {
              className: bem.element('auth-buttons-secondary-wrapper')
            },
              socialProviders.map((provider, index) => (
                tag('a', {
                  className: bem.element('auth-button-secondary', {
                    mobile: isMobile
                  }),
                  'data-provider': provider.id,
                  key: `provider-${index}`,
                  onClick: this.onSocialProviderClick
                },
                  provider.name
                )
              ))
            )
          )
      )
    )
  }
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  AuthSection.propTypes = {
    // Flags
    isAndroid: PropTypes.bool,
    isIos: PropTypes.bool,
    isMobile: PropTypes.bool,
    // Values
    className: PropTypes.string,
    downloadHref: PropTypes.string,
    // Callbacks
    onAppDownload: PropTypes.func,
    onSocialProviderAuth: PropTypes.func
  }
}

module.exports = AuthSection
